import React from 'react';

// Selector
import { getNewTransactionId } from '../../../../../../utils/undoRedo/undoRedoTransactionManager';
import {
    useLegacyActiveTableCallback,
    useLegacyActiveTableSelector,
} from '../../../../../../element/table/store/legacyHotTableStoreHooks';
import { selectLegacyActiveTableCellSelection } from '../../../../../../element/table/store/selectors/legacyActiveHotTableSelectors';
import { isSelectingMultipleSelections } from '../../../../../../element/table/legacy/utils/tableCellSelectionUtils';

// Components
import ToolbarTool from '../../../ToolbarTool';
import Icon from '../../../../../../components/icons/Icon';

// Actions
import { addHotTableRowsBelow } from '../../../../../../element/table/legacy/utils/hotInstanceUtils/hotTableGridOperationsUtils';

const LegacyAddRowTool: React.FC = (props) => {
    const currentCellSelections = useLegacyActiveTableSelector(selectLegacyActiveTableCellSelection);

    const onClick = useLegacyActiveTableCallback(
        (activeTable) => addHotTableRowsBelow(activeTable, undefined, getNewTransactionId()),
        [],
    );

    return (
        <div className="AddRowTool LegacyAddRowTool">
            <ToolbarTool
                {...props}
                onClick={onClick}
                isActive={false}
                disabled={isSelectingMultipleSelections(currentCellSelections)}
                tooltipEnabled={true}
                shortcut={['alt', '↓']}
            >
                <Icon name="toolbar-add-row" />
            </ToolbarTool>
        </div>
    );
};

export default LegacyAddRowTool;
